//@flow
import * as React from 'react';
import type {filtersFromParams, history, match} from "../../../../../../services/flowTypes/appFlowTypes";
import type {setFiltersToUrl} from "../../../../../../services/flowTypes/propFnFlowTypes";
import HistoryView from "../../../../../../components/composed/HistoryView/HistoryView";

type Props = {
  filtersFromParams: filtersFromParams,
  setFiltersToUrl: setFiltersToUrl,
  match:match,
  history: history
};

const ReportHistory = (props: Props) => {
  const reportId = +props.match.params.id;
  return (
    <HistoryView filtersFromParams={props.filtersFromParams} setFiltersToUrl={props.setFiltersToUrl}
                 historyType={'report'} itemId={reportId} routerHistory={props.history}/>
  );
};

export default ReportHistory;